import AdminMerchantModal from "./adminMerchantModal";

const MerchantInfoEdit = ({ open, close, merchant, refresh }) => (
  <AdminMerchantModal
    mode="edit"
    open={open}
    close={close}
    merchant={merchant}
    refresh={refresh}
  />
);

export default MerchantInfoEdit;
